import { Component } from '@angular/core';

@Component({
  selector: 'i360-empty-route',
  template: '',
})
export class EmptyRouteComponent {}
// TODO: use everywhere instead of `NoContentComponent`?
//  It is intended to prevent "404" page blinking when SPAs are unmounted on route change, but I haven't seen any.
//  Meanwhile, we _do_ need a "404" page for unknown routes...
